import { render, staticRenderFns } from "./ReportTabPage.vue?vue&type=template&id=5352c079&scoped=true&lang=pug"
import script from "./ReportTabPage.vue?vue&type=script&lang=js"
export * from "./ReportTabPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5352c079",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5352c079')) {
      api.createRecord('5352c079', component.options)
    } else {
      api.reload('5352c079', component.options)
    }
    module.hot.accept("./ReportTabPage.vue?vue&type=template&id=5352c079&scoped=true&lang=pug", function () {
      api.rerender('5352c079', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/powerbi/components/report/ReportTabPage.vue"
export default component.exports